export default "__VITE_ASSET__BksTYHxV__"